module.exports = __webpack_public_path__ + "static/img/aboutUs06.1bff7dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs06.jpg
// module id = 1358
// module chunks = 1